import { Theme, alpha } from "@mui/material/styles"

import { LightVsDarkStylesParams } from "@helpers/lightVsDarkStyles"

import * as colors from "@constants/colors"

export const activeLinkStyles = ({
  isActive,
  theme,
}: {
  isActive: boolean
  theme: Theme
}): LightVsDarkStylesParams => ({
  lightStyles: {
    backgroundColor: isActive
      ? alpha(colors.neutral.black, 0.05)
      : "transparent",
    color: isActive ? theme.palette.text.primary : theme.palette.text.secondary,
  },
  darkStyles: {
    backgroundColor: isActive
      ? alpha(colors.neutral.white, 0.1)
      : "transparent",
    color: isActive ? theme.palette.text.primary : theme.palette.text.secondary,
  },
})
